import { render, staticRenderFns } from "./ExperianFooter.vue?vue&type=template&id=8d050c7e&"
import script from "./ExperianFooter.vue?vue&type=script&lang=js&"
export * from "./ExperianFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports